export const config = {
  title: "Pharma Scientific LLC | HPLC GC LCMS Repair Services in Clifton, NJ",
  meta: {
    description:
      "Pharma Scientific LLC offers expert HPLC, GC, and LCMS repair services. Serving laboratories in Clifton, NJ and nearby areas with reliable instrumentation support.",
    keywords: [
      "HPLC repair Clifton NJ",
      "GC services",
      "LCMS repair",
      "Pharma Scientific LLC",
      "analytical instrument repair",
      "lab equipment service New Jersey"
    ],
    author: "Pharma Scientific LLC",
    canonicalUrl: "https://www.hplcgclcmsrepairservicespharmascientificllc.org/",
  },
  sections: {
    header: {
      businessName: "Pharma Scientific LLC",
    },
    sectionB: {
      heroTitle: "Precision Repairs. Reliable Results.",
      heroSubtitle: "Expert HPLC, GC, and LCMS Instrumentation Support in Clifton, NJ",
      learnAboutText: "Request Service",
      phoneNumber: "7327637930",
      phoneLabel: "(732) 763-7930",
      heroBackgroundImage:
        "https://media.istockphoto.com/id/658521158/photo/vials-are-arranged-in-the-auto-sampler-for-the-lab-equipment.jpg?s=612x612&w=0&k=20&c=5eF5U8zPXAQB58Vxb9nHx6XhM397Sh82cdIicSYtTZQ=",
      cardData: [
        {
          title: "HPLC Systems",
          description: "Maintenance and repair for a wide range of HPLC instruments.",
        },
        {
          title: "GC Instruments",
          description: "Expert support for Gas Chromatography systems.",
        },
        {
          title: "LCMS Support",
          description: "High-performance repairs for LCMS instruments.",
        },
      ],
      description:
        "Pharma Scientific LLC specializes in servicing analytical instruments for laboratories across New Jersey. Our team delivers dependable diagnostics, calibration, and repairs for HPLC, GC, and LCMS systems.",
    },
    sectionC: {
      servicesTitle: "Our Services",
      servicesDescription:
        "We keep your lab running efficiently with expert-level repair, calibration, and maintenance services.",
      cards: [
        {
          title: "HPLC Repair",
          description: "Servicing leading brands of HPLC systems with OEM standards.",
          imageSrc: "https://media.istockphoto.com/id/1433586203/photo/smiling-young-woman-in-a-laboratory-for-medicine-innovation-and-development-while-reading-or.jpg?s=612x612&w=0&k=20&c=ScnH3ThAHnyhnaruT95gfovhVhfCfkwYcxKbI_vI6oQ=",
          imageAlt: "HPLC repair service",
        },
        {
          title: "GC Instrument Maintenance",
          description: "Complete solutions for gas chromatography system servicing.",
          imageSrc: "https://media.istockphoto.com/id/157645661/photo/sample-phials-on-a-gas-chromatograph.jpg?s=612x612&w=0&k=20&c=ysvl9lbhuC4EqLSzBPdWu8syk-Fr9zJ9KRDhEpgn2Zc=",
          imageAlt: "Gas chromatography support",
        },
        {
          title: "LCMS Diagnostics",
          description: "Advanced LCMS diagnostics and component-level repairs.",
          imageSrc: "https://media.istockphoto.com/id/523752279/photo/two-young-researchers-carrying-out-experiments-in-a-lab.jpg?s=612x612&w=0&k=20&c=I2g4Q-InUjj7LIvPIVbiSGuSY8CAWh-2hMfIiiND0Ow=",
          imageAlt: "LCMS lab service",
        },
      ],
      otherServicesTitle: "Why Choose Us",
      otherServicesList: [
        "Certified Instrument Technicians",
        "Quick Turnaround Time",
        "Service Across New Jersey",
        "OEM Quality Repairs",
        "Responsive Support",
      ],
    },
    sectionD: {
      aboutTitle: "About Pharma Scientific LLC",
      aboutImage: {
        src: "https://images.squarespace-cdn.com/content/v1/68a901d1aabcc92f0f32f48b/fc572db3-2249-4490-ad5d-494a5060779d/waters+main.jpg?format=1500w",
        alt: "Pharma Scientific Laboratory Tools",
      },
      aboutText: [
        "Pharma Scientific LLC is a trusted service provider for analytical laboratories, focusing on HPLC, GC, and LCMS instrumentation. Based in Clifton, NJ, we serve a wide range of clients across the region.",
        "With years of technical experience and industry insight, we ensure that your instruments deliver consistent and accurate results.",
      ],
    },
    sectionE: {
      profileImage: null,
      profileAlt: "Pharma Scientific LLC Logo",
      businessName: "Pharma Scientific LLC",
      contact: {
        phone: "7327637930",
        phoneLabel: "(732) 763-7930",
        email: "pharma.scientificllc@gmail.com",
        website: "https://www.hplcgclcmsrepairservicespharmascientificllc.org/",
        address: "Clifton, New Jersey 08619, USA",
      },
      socialMedia: {},
    },
    sectionF: {
      address: "Clifton, New Jersey 08619, USA",
      googleMapsEmbedUrl:
        "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d15173.08626105347!2d-74.174033!3d40.898592!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x89c2f90d89e489a7%3A0x6f1b1b1c27e5e528!2sClifton%2C%20NJ%2008619%2C%20USA!5e0!3m2!1sen!2sus!4v169…"
    },      
  },
};

export default config;
